function isBST(date: Date): boolean {
  // BST starts on the last Sunday of March and ends on the last Sunday of October
  const year = date.getFullYear();
  const marchLastSunday = new Date(year, 2, 31); // March 31
  while (marchLastSunday.getDay() !== 0) { // While not Sunday
    marchLastSunday.setDate(marchLastSunday.getDate() - 1);
  }
  const octoberLastSunday = new Date(year, 9, 31); // October 31
  while (octoberLastSunday.getDay() !== 0) { // While not Sunday
    octoberLastSunday.setDate(octoberLastSunday.getDate() - 1);
  }
  
  // BST is active if date is between these Sundays at 1am UTC
  const startBST = new Date(marchLastSunday.getTime() + 3600000); // Add 1 hour for 1am
  const endBST = new Date(octoberLastSunday.getTime() + 3600000);
  
  return date >= startBST && date < endBST;
}

export function formatDateTime(date: Date | string, skipTimeAdjustment: boolean = false): string {
  // Create now date and add 2 hours to match server time
  const now = new Date();
  now.setHours(now.getHours() + 2);
  
  // Create reading date and adjust time if needed
  const readingDate = new Date(date);
  if (!skipTimeAdjustment) {
    readingDate.setMinutes(readingDate.getMinutes() + 60);
  }
  
  // Debug logging
  console.log('Time debug:', {
    input: date,
    skipTimeAdjustment,
    readingDate: readingDate.toISOString(),
    readingTime: readingDate.getTime(),
    now: now.toISOString(),
    nowTime: now.getTime(),
    simpleDiff: Math.floor((now.getTime() - readingDate.getTime()) / 60000)
  });

  // Simple time difference in milliseconds
  const diff = now.getTime() - readingDate.getTime();
  const diffMinutes = Math.floor(diff / 60000);
  const diffHours = Math.floor(diff / 3600000);
  const diffDays = Math.floor(diff / 86400000);

  // If less than 24 hours ago, show relative time
  if (diffDays < 1) {
    if (diffMinutes < 60) {
      return `${diffMinutes}m ago`;
    }
    return `${diffHours}h ago`;
  }

  // If this year, show date without year
  if (readingDate.getFullYear() === now.getFullYear()) {
    return readingDate.toLocaleDateString(undefined, {
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit'
    });
  }

  // If different year, show with year
  return readingDate.toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
}